/**
 * Утилиты для работы с мобильными устройствами
 * Исправляет проблемы с автофокусом поля поиска на iOS и Android
 */
import React from 'react';

/**
 * Проверяет, является ли устройство мобильным (iOS или Android)
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;

  return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
}

/**
 * Конфигурация для поля ввода, которая предотвращает автофокус на мобильных устройствах
 *
 * Проблема: На мобильных устройствах поля ввода автоматически получают фокус
 * при загрузке страницы или открытии меню, что приводит к появлению клавиатуры
 * и закрывает половину экрана.
 *
 * Решение: Устанавливаем readOnly для мобильных устройств и убираем его
 * только при намеренном клике пользователя.
 */
export function getMobileInputProps() {
  const isMobile = isMobileDevice();

  return {
    readOnly: isMobile,
    onTouchStart: isMobile
      ? (e: React.TouchEvent<HTMLInputElement>) => {
          // Убираем readonly при намеренном клике пользователя
          const input = e.currentTarget;
          input.removeAttribute('readonly');
          setTimeout(() => {
            input.focus();
          }, 100);
        }
      : undefined,
  };
}

/**
 * Хук для предотвращения автофокуса на мобильных устройствах
 */
export function useMobileInputConfig() {
  return getMobileInputProps();
}
